import { defineMessages } from 'react-intl';

import CREDIT_SCORES from './CreditScores';


const MESSAGES = defineMessages({
    [CREDIT_SCORES.EXCELLENT]: {
        id: 'edb.cc.credit-score.excellent',
        defaultMessage: 'Excellent (760+)',
    },
    [CREDIT_SCORES.VERY_GOOD]: {
        id: 'edb.cc.credit-score.very-good',
        defaultMessage: 'Very Good (725\u2011759)',     // non-breaking hyphen; use of {nbhy} currently breaks dropdowns
    },
    [CREDIT_SCORES.GOOD]: {
        id: 'edb.cc.credit-score.good',
        defaultMessage: 'Good (660\u2011724)',
    },
    [CREDIT_SCORES.FAIR]: {
        id: 'edb.cc.credit-score.fair',
        defaultMessage: 'Fair (560\u2011659)',
    },
    [CREDIT_SCORES.POOR]: {
        id: 'edb.cc.credit-score.poor',
        defaultMessage: 'Poor (below\u00A0560)',     // non-breaking space; use of {nbsp} currently breaks dropdowns
    },
    [CREDIT_SCORES.NONE]: {
        id: 'edb.cc.credit-score.none',
        defaultMessage: 'I don’t know it',
    },
});

const CREDIT_SCORES_OPTIONS = Object.values(CREDIT_SCORES).map(value => ({
    value: value,
    label: MESSAGES[value],
}));


export default CREDIT_SCORES_OPTIONS;
